import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { domainForSegment, NavigateConst, ANALYTICS_MESSAGES } from 'common';
import { Headings, GlobalErrorAlert, CheckIconBig, Paragraph, Button } from '@sentara-health/optimahealth_web';
import { useAdobeAnalytics } from '@sentara-health/platform-analytics';
import { AdobeFormConfig } from 'common/AdobeFormConfig';

interface ActivationSuccessProps {
  readonly guest?: boolean;
}

function ActivationSuccess({ guest }: ActivationSuccessProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { formSubmissionSucceeded, contentListingItemClicked } = useAdobeAnalytics();
  const { pathname } = useLocation();
  const hasTracked = useRef(false);
  const isChildOnlyDr = pathname === NavigateConst.childOnlyPlanDesignatedRep;

  let searcUrl = window.location.search
  let newParams = new URLSearchParams(searcUrl);
  let proxyId = newParams.get('proxy');

  useEffect(() => {
    if (!hasTracked.current) {
      formSubmissionSucceeded({
        segment: `${domainForSegment}${pathname}`,
        form: AdobeFormConfig['activationSuccess']
      });
      hasTracked.current = true;
    }
  }, []);

  const onSubmit = async () => {
    if (isChildOnlyDr) {
      contentListingItemClicked({
        segment: `${domainForSegment}${pathname}`,
        contentListing: {
          eventType: 'Content Listing Item Clicked',
          listing: {
            content: [{ ...ANALYTICS_MESSAGES.DR_CONTENT_LISTING.DESIGNATED_REP_SIGNIN_CLICK }],
          },
        },
      });
    }
    if (proxyId) {
      navigate(`${NavigateConst.signIn}?redirect=/?proxy=${proxyId}`);
    } else {
      navigate(NavigateConst.signIn);
    }
  };

  return (
    <div className="row justify-content-center">
      {guest ? (
        <div className="mb-4 pb-2">
          <GlobalErrorAlert
            variant="alert"
            dataTestId="alertShowWarningErrorMessage"
          >
            {t(
              'common.ErrorMessage'
            )}
          </GlobalErrorAlert>
        </div>
      ) : null}
      <div className="col-xl-6 col-md-8 col-12 text-center">
        <CheckIconBig className='modal-icon' />
        <Headings
          level={1}
          text={t('common.activationSuccess')}
          variant="semiBold"
          data-testid="activationSuccess"
          className="my-4 pb-1"
        />
        <Paragraph
          text={t('activation.activationSuccessMessage')}
          className="lineBrake lh-1" data-testid="activationSuccessMessage" />
        <div className="py-3 my-4">
          <Button
            onClick={onSubmit}
            data-testid={'continueButton'}
            type="submit"
            variant="primary_btn"
            className="btn-md-width"
          >
            {t('common.signIn')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ActivationSuccess;
